// Is this page running as a Discord Activity? Discord loads the Activity in
// an iframe on https://<client id>.discordsays.com/ (its proxy in front of
// wizardpoker.online) with frame_id, instance_id and platform in the query
// string; the Embedded App SDK needs all three. This file is tiny and has no
// dependencies: the SDK itself (discordSdk.ts) is only loaded inside Discord.
//
// Networking needs no rewriting: the Activity's own origin is Discord's proxy,
// whose "/" URL mapping points at wizardpoker.online, so the app's relative
// URLs (/api/..., /ws/..., /assets/..., /music/...) already go through it.

export interface ActivityLaunch {
  /** Same for everyone who joined this run of the Activity (e.g. one voice channel). */
  instanceId: string;
}

const INSTANCE_ID_RE = /^[A-Za-z0-9_-]{1,128}$/;

export function activityLaunch(search: string = window.location.search): ActivityLaunch | null {
  const q = new URLSearchParams(search);
  const instanceId = q.get("instance_id");
  if (!q.get("frame_id") || !q.get("platform") || !instanceId || !INSTANCE_ID_RE.test(instanceId)) return null;
  return { instanceId };
}

/** The launch parameters when running inside Discord, read once at startup. */
export const ACTIVITY: ActivityLaunch | null = activityLaunch();

/** True inside the Discord Activity (sessions are bearer tokens, no login screen, no logout). */
export const IN_DISCORD = ACTIVITY !== null;
